/**
 * 알림 타입 enum
 */
export const ALARMED_TYPE = {
  SPECIAL_LOAN: "특판대출",
};

export default {
  ALARMED_TYPE,
};
